/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import React, { Component, createRef, forwardRef } from 'react';
import { Button, Form, Row, Col, FormControl, Dropdown } from 'react-bootstrap';
import axios from 'axios';

// project imports
import { itemReport, salelist, locationlist } from 'shared/settings/apiconfig';
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';

// style imports
import "react-datepicker/dist/react-datepicker.css";
import './Item.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to show sale list in table
 * 
 * @param props
 * 
 * @return  item report  html code
 * 
**/

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="custom-drop-down"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/media/arrow.984f931e.svg`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));

export default class SaleItem extends Component {
    initialSearchState;
    search;
    startDatePicker;
    endDatePicker;
    config;
    id;
    filterSearch;
    constructor(props) {
        super(props);
        /* initial search state */
        this.initialSearchState = {
            saletitle: { field: "saletitle", value: "", op: "=", join: "AND" },
            saleid: { field: "saleid", value: "", op: "=", join: "AND" },
            sku: { field: "sku", value: "", op: "LIKE", join: "AND" },
            itemtitle: { field: "itemtitle", value: "", op: "LIKE", join: "AND" },
            locationid: { field: 'locationid', value: '', op: '=', join: 'AND' },
        }
        this.state = {
            search: this.initialSearchState,
            searchData: false,
            modal: false,
            tableData: [],
            salesDetails: {},
            sales: [],
            categorylist: [],
            issearch: false,
            searchInput: null,
            showSearchBox: false,
            locations: [],
            isdisabled: false,
            location: '',
            locationlength: 0,
            Selected_salename: "",
            errorpageredirect: false,
            errorType: ''
        }
        this.config = {
            name: 'item report',
            url: itemReport,
            isReport: true,
            params: {},
            columns: [
                // { columnType: 'custom', customColumn: (row) => this.customFiled(row, "bidresultplacement"), name: 'Bid Result', property: 'bidresultplacement', sort: false, width: '150px',maxWidth: '150px' },
                // { columnType: 'custom', customColumn: (row) => this.customAmount(row, "amount"), name: 'Amount', property: 'amount', sort: false, width: '150px',maxWidth: '150px' },
                { columnType: 'custom', customColumn: (row) => this.customFiled(row, "firstname"), name: 'First Name', property: 'firstname', sort: false, width: '180px', maxWidth: '180px' },
                { columnType: 'custom', customColumn: (row) => this.customFiled(row, "lastname"), name: 'Last Name', property: 'lastname', sort: false, width: '180px', maxWidth: '180px' },
                // { columnType: 'custom', customColumn: (row) => this.customFiled(row, "nickname"), name: 'Nick Name', property: 'nickname', sort: false, width: ' 180px',maxWidth: '180px' },
                // { columnType: 'custom', customColumn: (row) => this.customFiled(row, "email"), name: 'Email ID', property: 'email', sort: false, width: '180px',maxWidth: '180px' },
                // { columnType: 'custom', customColumn: (row) => this.customFiled(row, "mobilenumber"), name: 'Phone Number', property: 'mobilenumber', sort: false, width: '150px',maxWidth: '150px' },
                { name: 'SKU', property: 'sku', sort: true, width: '150px' },
                { name: 'Item Title', property: 'itemtitle', sort: true, width: '250px', columnType: 'custom', customColumn: (row) => { if ('itemtitle' in row) return (row.itemtitle) } },
                {
                    /*   name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: "CSV", width: '170px',
                      actionEvents: {}, accordion: this.accordionValue */
                    name: '', property: 'id', columnType: 'actions', actions: [], customHeader: "CSV", width: '170px',
                }
            ],

            sort: [],
            pagination: true,
            field: ["firstname", "lastname", "nickname", "mobilenumber", "email", "amount", "bidresultplacement", "itemtypeid"],
            filename: "sign-off-report",
            defaultFilter: [
                { field: "itemtypeid", value: "2", op: "=", join: "AND" },
            ],
            csvColumn: [
                { name: 'Sale Title', property: 'saletitle', columnType: 'custom', customColumn: (row) => { if ('saletitle' in row) return (row.saletitle) } },
                { name: 'Item ID', property: 'itemid', },
                { name: 'Signature', },
                { name: 'Date', },

            ]
        };
        this.search = {};
        this.startDatePicker = false;
        this.endDatePicker = false;
        this.id = null;
        this.sales = [];
        this.filterSearch = {};
        this.dataTable = createRef();
        this.locations = [];
    }

    // customAddQuotes = (values) => {
    //     return values.replace(/"/g, '""')
    // }

    componentDidMount = () => {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    CustomMenu = React.forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={`${className} w-100`}
                    aria-labelledby={labeledBy}
                >
                    {
                        this.state.showSearchBox ?
                            <FormControl
                                autoFocus
                                className="mx-auto my-2 w-95 border-normal"
                                placeholder="Type to filter..."
                                onChange={(e) => { this.searchSaleList(e.target.value) }}
                                value={this.state.searchInput}
                                ref={this.searchRef}
                            /> : <div className="text-center my-2">Loading...</div>
                    }
                    {
                        this.state.showSearchBox ?
                            <ul className="list-unstyled">
                                {React.Children.toArray(children).filter(
                                    (child) => child
                                )}
                            </ul> : null
                    }
                </div>
            );
        },
    );


    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    customFiled(row, property) {
        if ("bidders" in row && row["bidders"].length > 0) {
            var filter = row["bidders"].filter(item => item.bidresultplacement === "Winner")
            return (filter[0][property])
        }
        else {
            return ("- - -")
        }
    }
    customAmount(row, property) {
        if ("bidders" in row && row["bidders"].length > 0) {
            var filter = row["bidders"].filter(item => item.bidresultplacement === "Winner")
            return (`${parseFloat(filter[0][property]).toFixed(2)}`)
        }
        else {
            return ("- - -")
        }
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'saleid') {
            eventValue = Number(eventValue)
        }
        if (event.target.name === 'locationid') {
            this.setState({
                ...this.state,
                issearch: true,
                isdisabled: true,
                Selected_salename: "",
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: Number(eventValue)
                    }
                }
            }, () => {
                this.getSaleList();
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
        else {
            this.setState({
                ...this.state,
                issearch: true,
                search: {
                    ...this.state.search,
                    [event.target.name]: {
                        ...this.state.search[event.target.name],
                        value: eventValue
                    }
                }
            }, () => {
                if (event.target.value === '')
                    this.checkSearch();
            });
        }
    }

    /* Get sales list */
    getSaleList = () => {
        let filter = []
        if (!this.state.search.locationid.value) {
            filter = [
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        } else {
            filter = [
                { field: 'locationid', value: this.state.search.locationid.value, op: '=', join: 'AND' },
                { field: 'status', value: 'Closed', op: '=', join: 'AND' },
            ];
            if (this.state.searchInput) {
                filter.push(
                    { field: 'title', value: `%${this.state.searchInput}%`, op: 'LIKE', join: 'AND' }
                );
            }
        }
        let field = ["title", "id"]
        var data = {
            "field": field,
            "filter": filter
        };
        axios.post(getSellerUrl(salelist), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.sales = response.data.data;
                    const temp = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        ...this.state,
                        sales: temp,
                    });
                }
            })
            .catch(error => {
            });
    }
    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
            isdisabled: false,
            Selected_salename: ''
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            saleid: { ...this.state.search.saleid, value: this.state.search.saleid.value },
            sku: { ...this.state.search.sku, value: this.state.search.sku.value !== '' && `%${this.state.search.sku.value}%` },
            itemtitle: { ...this.state.search.itemtitle, value: this.state.search.itemtitle.value !== '' && `%${this.state.search.itemtitle.value}%` },
            locationid: { ...this.state.search.locationid },

        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "').replace(/null/g, '"- - - "')
        row = JSON.parse(row)
        if (row && Object.keys(row).length && 'bidders' in row && row.bidders.length > 1) {
            return (
                <div className="accordscroll">

                    {row.bidders.map((item, key) => (

                        <table class="table-box">
                            <tbody className="table-body">
                                {key !== 0 && <div className="w-100">
                                    <tr className="row-height">
                                        <td style={{ width: "150px", padding: "10px" }}>
                                            <div className="textWrap" style={{ color: "#b6576e" }}>{item.bidresultplacement}</div>
                                        </td>
                                        <td style={{ width: "150px", padding: "10px" }}>
                                            <div className="textWrap" style={{ color: "#b6576e" }}>{item.amount}</div>
                                        </td>
                                        <td style={{ width: "180px", padding: "10px" }}>
                                            <div style={{ color: "#b6576e", wordBreak: "break-word" }}>{item.firstname}</div>
                                        </td>
                                        <td style={{ width: "180px", padding: "10px" }}>
                                            <div style={{ color: "#b6576e", wordBreak: "break-word" }}>{item.lastname}</div>
                                        </td>
                                        <td style={{ width: "180px", padding: "10px" }}>
                                            <div style={{ color: "#b6576e", wordBreak: "break-word" }}>{item.nickname}</div>
                                        </td>
                                        <td style={{ width: "180px", padding: "10px" }}>
                                            <div style={{ color: "#b6576e", wordBreak: "break-word" }}>{item.email}</div>
                                        </td>
                                        <td style={{ width: "150px", padding: "10px" }}>
                                            <div className="textWrap" style={{ color: "#b6576e" }}>{item.mobilenumber}</div>
                                        </td>
                                    </tr>
                                </div>}
                            </tbody></table>

                    ))}
                </div>
            );
        }
        else {
            return (
                <div style={{ padding: "1% 2%", textAlign: "center", color: "rgb(182, 87, 110)", }}>No Data</div>
            );
        }
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    toggleSearchBox = (event) => {
        setTimeout(() => {
            this.setState({
                showSearchBox: event,
                sales: [],
                searchInput: null,
            });
        }, event ? 500 : 100);
    }

    searchSaleList = (value) => {
        this.setState({
            searchInput: value
        }, () => {
            this.getSaleList();
        });
    }

    saleSelect = (sale) => {
        if (this.state.search.saletitle.value !== sale.title) {
            this.setState({
                searchInput: null,
                sales: [],
                Selected_salename: sale.title
            }, () => {
                const event = {
                    "target": {
                        "name": "saleid",
                        "value": sale.id
                    }
                };
                this.searchInputChange(event);
            });
        }
    }

    /* Get Location list */
    getLocationList = async () => {
        await axios.all([
            axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders()),
        ])
            .then(response => {
                this.locations = response[0].data.data;
                if (this.locations.length == '1') {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                        isdisabled: true,
                        search: {
                            ...this.state.search,
                            locationid: {
                                ...this.state.search.locationid,
                                value: this.locations[0].id
                            },
                        }
                    }, () => {
                        this.getSaleList();
                    });
                }
                else {
                    this.setState({
                        ...this.state,
                        locations: ArrayValueReorder(response[0].data.data, 'title'),
                        location: this.locations[0].title,
                        locationlength: this.locations.length,
                    })
                }
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }
    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                <div className="sale-search">
                    <div className="sales-list-search">
                        <Form className="sales-list-font">
                            <div className="sales-search-container">
                                <Row>
                                    <Col>
                                        <label>Location *</label>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Please select location</option>
                                            {/* {this.state.locations.length > 1 ? <option value="All">All</option> : ''} */}
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>Sale Title</label>
                                        {/* <Form.Control as="select" name="saleid" value={this.state.search.saleid.value} disabled={!this.state.search.locationid.value} onChange={(event) => { this.searchInputChange(event) }}>
                                            <option value="" disabled>Select Sale</option>
                                            {this.state.sales.map((sale, index) =>
                                                <option key={index} value={sale.id}>{sale.title}</option>
                                            )}
                                        </Form.Control> */}
                                        <Dropdown onToggle={(event) => this.toggleSearchBox(event)}>
                                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                {this.state.Selected_salename ? this.state.Selected_salename : "Select Sale"}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu as={this.CustomMenu} className="custom-dropdown-menu" >

                                                {this.state.sales.map((sale, index) => {
                                                    return (
                                                        <Dropdown.Item key={sale.id} eventKey={sale.title} onClick={() => this.saleSelect(sale)} active={this.state.search.saletitle.value === sale.title}>
                                                            {sale.title}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>
                                    <Col>
                                        <label>Item Title</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="itemtitle" value={this.state.search.itemtitle.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                    <Col>
                                        <label>SKU</label>
                                        <Form.Control onKeyDown={this._handleKeyDown} name="sku" value={this.state.search.sku.value} onChange={(event) => { this.searchInputChange(event) }}>
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <Row className="d-flex" style={{ marginBottom: "-1%" }}>
                                    <Col md={6}></Col>
                                    <Col md={6}>                                        <div className="buttonClass" style={{ marginTop: 15 }}>
                                        <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                        <Button variant="seller-search" disabled={this.state.locationlength > '1' ? !this.state.isdisabled : !this.state.isdisabled} onClick={() => this.enableSearch()}>Search</Button>
                                    </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </div>
                </div>
                <div className="sale-list">
                    <Datatable config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData}></Datatable>
                </div>
            </div>
        );
    }
}